import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'benefits-app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  standalone: false
})
export class TermsComponent {
  @Output() closeTerms = new EventEmitter();
}
